import { Component, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { SignupStateService } from '../../services/signup-state.service';
import { UserService } from 'src/app/dashboard/services/user.service';
import { buildUserPayload } from '../../utils/build-user-payload';
import { mensajeDeErrorDeRegistro } from '../../utils/registration-error';

type PepOption = 'no-pep' | 'is-pep' | null;

@Component({
  selector: 'app-pep-selection-step',
  templateUrl: './pep-selection-step.component.html',
  styleUrls: ['./pep-selection-step.component.sass'],
})
export class PepSelectionStepComponent {
  @Output() onError = new EventEmitter<string>();
  @Output() onSuccess = new EventEmitter<string>();

  selectedOption: PepOption = null;
  loading = false;

  /** Explicacion de que es un PEP: colapsada, se abre a pedido. */
  showPepInfo = false;

  constructor(
    public signupState: SignupStateService,
    private userService: UserService,
    private router: Router
  ) {
    // Restaurar seleccion previa si existe
    if (this.signupState.hasPepSelection) {
      this.selectedOption = this.signupState.isPoliticamenteExpuesto ? 'is-pep' : 'no-pep';
    }
  }

  selectOption(option: PepOption): void {
    this.selectedOption = option;
  }

  async continue(): Promise<void> {
    if (!this.selectedOption) return;

    this.loading = true;

    try {
      if (this.selectedOption === 'no-pep') {
        // Sin vinculos PEP - registrar usuario
        this.signupState.setPoliticamenteExpuesto(false);
        await this.registerUser();
      } else {
        // Con vinculos PEP - ir al formulario de declaracion
        this.signupState.setPoliticamenteExpuesto(true);
        await this.signupState.nextStep(); // Paso 9
      }
    } catch (err: any) {
      this.onError.emit(err?.message || 'Error al procesar. Intenta nuevamente.');
    } finally {
      this.loading = false;
    }
  }

  /**
   * Registra el usuario en el backend
   */
  private async registerUser(): Promise<void> {
    const user = buildUserPayload(
      this.signupState.currentState,
      this.signupState.documentType,
      false
    );

    try {
      await this.userService.sendUserVerification({ user });
      this.onSuccess.emit('Registro completado exitosamente');
      this.signupState.completeRegistration();
      this.router.navigate(['/auth/sign-in']);
    } catch (err: any) {
      throw new Error(mensajeDeErrorDeRegistro(err));
    }
  }

  async goBack(): Promise<void> {
    await this.signupState.prevStep();
  }
}
